<template>
    <div></div>
</template>
<script>
export default {
    watch: {
        '$store.getters.REDIRECT': function () {
            if (this.$store.getters.REDIRECT) {
                this.$router.push(this.$store.getters.REDIRECT);
                this.$store.commit('reDirect', null);
            }
        }
    }
}
</script>
<style></style>